import type { LaneManifest } from "@/runtime/events";

export const LOCAL_LANE_MANIFESTS: Record<LaneManifest["lane"], LaneManifest> = {
  vad: {
    id: "local-silero-vad-v5.1",
    lane: "vad",
    label: "Silero VAD ONNX",
    version: "5.1.0",
    bytes: 2327524,
    files: [
      {
        path: "/models/vad/local-silero-vad-v5.1/silero_vad.onnx",
        bytes: 2327524,
        sha256: "1a153a22f4509e292a94e67d6f9b85e8deb25b4988682b7e174c65279d8788e3"
      }
    ]
  },
  stt: {
    id: "local-whisper-tiny-en-ggml-q5-1-v1",
    lane: "stt",
    label: "Whisper Tiny EN ggml Q5_1 (whisper.cpp)",
    version: "1.0.0",
    bytes: 32166155,
    files: [
      {
        path: "/models/stt/local-whisper-tiny-en-ggml-q5-1-v1/ggml-tiny.en-q5_1.bin",
        bytes: 32166155,
        sha256: "c77c5766f1cef09b6b7d47f21b546cbddd4157886b3b5d6d4f709e91e66c7c2b",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "1f1ac551e2d7b6d974ca05cbf557173d9d161619e0368dad0845b9df81e9849f"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "d15a8bfbe7a1223285bcd6aeb261a5d1cf006baf0e096b82e64cfbaa421ed223"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "4db565001e5e20306eb0575851170254e8059d5c11a8d1450fda084c5acd31a9"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "706a21acb580dd31617af05abe85a515a2c6880734afc73c5988302256b7e3b8"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "74e92edb8164a6cb6cc2b03dc87101d6c5483d93224176c95f579ffc95311556"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "aa9fce4a96bcb68b2609851f5eac9b3d3969beda335d5335b33b7ab22fbf1dda"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "23ee3abb18edbedc258eb484b156de15eb72ddc95081965c0b93c6819a06f89d"
          },
          {
            offset: 29360128,
            bytes: 2806027,
            sha256: "6bcf1b0548c0fa373cd6f690da1fa911130c68a03eff6a01c4c9c19e283aac32"
          }
        ]
      }
    ]
  },
  llm: {
    id: "local-smollm2-135m-instruct-q4-k-m-v1",
    lane: "llm",
    label: "SmolLM2 135M Instruct GGUF Q4_K_M",
    version: "1.0.0",
    bytes: 105454432,
    files: [
      {
        path: "/models/llm/local-smollm2-135m-instruct-q4-k-m-v1/SmolLM2-135M-Instruct-Q4_K_M.gguf",
        bytes: 105454432,
        sha256: "2e8040ceae7815abe0dcb3540b9995eaa1fa0d2ca9e797d0a635ae4433c68c2d",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "b86f99230d36a5fdf6863dc33bdac6b084cf137f89ba15a9c9635a4f214ecb83"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "8723ad2051cadd0db36c338a63406074b4c2ea2f6789053a76a16f05cc8c37db"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "b651937a5881fcbcffba6a70272affcf67bdfbefe03bd721537344eaddcfdd2b"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "ee798d43b0d47e0c2763f356077a0c98e1c9da57c73b6178e36575039f51aae7"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "7f933f7f3bf47333b637097dc613e88302badae234089b8bed683b2f85f63333"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "2372007167bcdf7466311fd8d9eca0ddea2ccc55c66ccbc97361a2cebd0c448b"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "083ba40a2ad815999cef38f531d8a767810996aa18008e31bdb38c047f1632c4"
          },
          {
            offset: 29360128,
            bytes: 4194304,
            sha256: "ffb52ce676d1617b51caf240f773bf0e6f5b8d6d75d02acc0b1baa5e4a14b4d8"
          },
          {
            offset: 33554432,
            bytes: 4194304,
            sha256: "f0966019b36eb4c94001fc6a0ec90c146d23c424a55fc372fd227540363b96e5"
          },
          {
            offset: 37748736,
            bytes: 4194304,
            sha256: "3966f6222a630183c2d93ccd4f43f7d722210b7c76b8aa72824825f096c9154b"
          },
          {
            offset: 41943040,
            bytes: 4194304,
            sha256: "861bc4b1764c06020ab55db4ad20732957c8291a4b239ca1185a19486c41751e"
          },
          {
            offset: 46137344,
            bytes: 4194304,
            sha256: "5fed22091137dcb3407d5229847e9908df07eeaab84dde32c1882acd51cc0d79"
          },
          {
            offset: 50331648,
            bytes: 4194304,
            sha256: "22700adbe8c16f31655a828084dd1c77204fd4c7f82f31a56e3b1e14cde6ec9d"
          },
          {
            offset: 54525952,
            bytes: 4194304,
            sha256: "d38e486112b028a1229571c8d875c652d24944d3bffa307ca52d27589da0b87b"
          },
          {
            offset: 58720256,
            bytes: 4194304,
            sha256: "91e03d885267584378bb75336f78ae06b4453dadcc183c19848d497f4d468fe9"
          },
          {
            offset: 62914560,
            bytes: 4194304,
            sha256: "8270175ab680bfb289a0bcc8c0fe1eafd369b31d9d7bc26247ec086ab2e875d1"
          },
          {
            offset: 67108864,
            bytes: 4194304,
            sha256: "55245461c33b3cebf726286e6c30dd05679e723e9df1beacaefe93c524ba4e23"
          },
          {
            offset: 71303168,
            bytes: 4194304,
            sha256: "3ef41f6132096acfb3d161c2e00915b5216f44910a234515f502df2d906646b8"
          },
          {
            offset: 75497472,
            bytes: 4194304,
            sha256: "7ebb6714edf3654a5ee44cdf53fa0607cf33cb8401030a4742c44f9939046c5e"
          },
          {
            offset: 79691776,
            bytes: 4194304,
            sha256: "b883550685c81f7d6ea6dd273eb5cbaa9641d99aac689e05606bb454ce994d93"
          },
          {
            offset: 83886080,
            bytes: 4194304,
            sha256: "24a3a72d4d7bbd83d71b1601fafc733d532f35daa7bb53950dbdeca7c67bed10"
          },
          {
            offset: 88080384,
            bytes: 4194304,
            sha256: "7a79a7b7fb58dba020c0af638188658c996adcaa42ff9044327e1cb50db57b12"
          },
          {
            offset: 92274688,
            bytes: 4194304,
            sha256: "d69959bbd3125878f25bde7f6ddae9c3fbada22dbcc5d929ead4ce3868d82c66"
          },
          {
            offset: 96468992,
            bytes: 4194304,
            sha256: "0da66e2ed048a430467ca6e5bbee62c1ef49e78e8002173b6a5913a0a7dbb844"
          },
          {
            offset: 100663296,
            bytes: 4194304,
            sha256: "19debe1aaf14431d7eff230b1b011df2f9749b7cb2bcf5a423ae6b57f4091d1a"
          },
          {
            offset: 104857600,
            bytes: 596832,
            sha256: "974b5a26bf19f9c989f4fe0cff95124f3bc353428241980c7bc5e3b0d11a0807"
          }
        ]
      }
    ]
  },
  tts: {
    id: "local-moss-tts-nano-100m-onnx-v1",
    lane: "tts",
    label: "OpenMOSS TTS Nano 100M ONNX",
    version: "1.0.0",
    bytes: 763191513,
    files: [
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/browser_poc_manifest.json",
        bytes: 503354,
        sha256: "097d80e993dc29f0bae427590b4f77084a161cb578b50d82c29f455d5faa9eee"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_decode_step.onnx",
        bytes: 291483,
        sha256: "698cbc2fc1c2feca16e5895614ed52bbb32ded10f236c076f477b2e69abf32d8"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_global_shared.data",
        bytes: 440813568,
        sha256: "bce8312c3df6a44545302cae229b61054fe0672e0b252ba59cba47adeed831dc",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "52b04456dac4371ddc6e2028b5b678c8d0d956b62bbedf36e33e18340b18e427"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "405cf8ea3fffb1ad698f626dece3e8d0d0d6f7c311c0ed221ec4ef6de35c62ed"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "356334c1fa1d3f40b858d87c54386899dbce4192189e8218000076e0d019ee72"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "b33b1564b0521a2a4f2d714b5824d0932d4142b34a2e65768e150d8c5143248a"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "448edc0a7aefbe947fe58af869e7b9b715dee82e16dee80b24363b61839b41fa"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "26c1a12566337a127a923f1d1cdc1c790fd2732894384ed6289c98c741fe92a5"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "44ee5330d4e3e6a8b6f8a0e05d080e3c009c3bd9d7c74f524c474a624d2b4924"
          },
          {
            offset: 29360128,
            bytes: 4194304,
            sha256: "c99f395f276f44bf8dfa8d3907f05b03d8dc7d966ab3407df868361cdb2c8b98"
          },
          {
            offset: 33554432,
            bytes: 4194304,
            sha256: "f3ee00b7d450ebcae3eda2e90b577890ace247d791eb69f6582b340b00a0229e"
          },
          {
            offset: 37748736,
            bytes: 4194304,
            sha256: "812238dd3da16c5db8b9570196d57713e20e01c414b83da42d943d3f4708d2e7"
          },
          {
            offset: 41943040,
            bytes: 4194304,
            sha256: "40e58b70e8e54d072d920c6a909496cfa3e28c667a29eb43a69d05a354c54c81"
          },
          {
            offset: 46137344,
            bytes: 4194304,
            sha256: "ec062543beba519fd58d95c094156ec8fbcf3c85d18749c061e1ab406eb0e177"
          },
          {
            offset: 50331648,
            bytes: 4194304,
            sha256: "075645214014b30402c2501b03ffeae8f3613ea4296c84ddb8232b25bb96a597"
          },
          {
            offset: 54525952,
            bytes: 4194304,
            sha256: "b20aed505a76d2e3903b4f0a497d82fe2c6c69dd4021a651afee26914a08d0a7"
          },
          {
            offset: 58720256,
            bytes: 4194304,
            sha256: "213d5edd885ecf976cbb576736d50351b873b84f07131cc679c8d80b4fba921b"
          },
          {
            offset: 62914560,
            bytes: 4194304,
            sha256: "2e8ee05e3591cc75f6976e396672ccd3b9151d3d7c19c2fb20c4e79dae07e66f"
          },
          {
            offset: 67108864,
            bytes: 4194304,
            sha256: "c79d05efcb495a6d2bd4827548ef353463a3c0be8c78bbfc8aa9bd9f1d121c76"
          },
          {
            offset: 71303168,
            bytes: 4194304,
            sha256: "2038c19e20558adf247cd06032f7908651dba0fd578b80818195fec98f590e1f"
          },
          {
            offset: 75497472,
            bytes: 4194304,
            sha256: "cbacb2e4596953ce805c0f04dccb3e31eae21201fcb5d4f6f50d2b7b2f72eb56"
          },
          {
            offset: 79691776,
            bytes: 4194304,
            sha256: "3667197567686a69f32668567aa16740402d1c8d18be3f0f1818b79b4260fd59"
          },
          {
            offset: 83886080,
            bytes: 4194304,
            sha256: "ebf3a003746ba6910a14de7767e4c8ccb6e803646a1b708d908856fbd77286d7"
          },
          {
            offset: 88080384,
            bytes: 4194304,
            sha256: "b24801905394f1d4e7c0a21cae1a6100c346dbbc224abc593ee425b7330aa6dc"
          },
          {
            offset: 92274688,
            bytes: 4194304,
            sha256: "0b7c1e660b15da4009ec4e7c051b0cb991613e15b3180ecad1c952f988fbd628"
          },
          {
            offset: 96468992,
            bytes: 4194304,
            sha256: "d403c987fe09d6709f00e92e988f572e85bddea677f2ce08b908204ff542b9e3"
          },
          {
            offset: 100663296,
            bytes: 4194304,
            sha256: "9f30d349d3de782d86cda8a8e007cce51bd4de63397846dedf71100c5db86075"
          },
          {
            offset: 104857600,
            bytes: 4194304,
            sha256: "231e1fbf0c9619b90eb1c2ccd7b0dce0129a632a549097ee384f550c695b89c1"
          },
          {
            offset: 109051904,
            bytes: 4194304,
            sha256: "275f426604a0012f7b220f50953b66cd5531b708e1f2e8d385dc5a9f2f7037d3"
          },
          {
            offset: 113246208,
            bytes: 4194304,
            sha256: "d9178cd95be3f04c2deb9ce4fc5a92e5a67becabfed3d302e4de93434590a4b8"
          },
          {
            offset: 117440512,
            bytes: 4194304,
            sha256: "7ba598c67bf881a7b4b151ec12de4cbbf10a78085e7d0e690b79e7d3fb62b1f3"
          },
          {
            offset: 121634816,
            bytes: 4194304,
            sha256: "7d853450f66ddba72f3f99c2bd38eb2b3fa93b29b5553cd50bdffce55b18644d"
          },
          {
            offset: 125829120,
            bytes: 4194304,
            sha256: "579bba003444a0a6fbca7d3b01bc37e7fbe2dd482a7ff349e365580720df21f7"
          },
          {
            offset: 130023424,
            bytes: 4194304,
            sha256: "5e6f17527f8d63989b64ae1edbcf1e43363fd3649b7a120daad74b8822a60b2e"
          },
          {
            offset: 134217728,
            bytes: 4194304,
            sha256: "688cd04cfa40693b86707688b4fe7e5ceafc14ac30db0723020255084169d61c"
          },
          {
            offset: 138412032,
            bytes: 4194304,
            sha256: "5702655c2f50fdb86f6dcdab8390c64fcf9a711486669863e2a16011d72e752a"
          },
          {
            offset: 142606336,
            bytes: 4194304,
            sha256: "bc7285e5adbba8b00df3cc3c855058230927d949f899f718510c74716cb49f7f"
          },
          {
            offset: 146800640,
            bytes: 4194304,
            sha256: "6d8a359bfed0ef370c2887fb4b91a4ea7b79662a09720ed0c390cb34a83de40f"
          },
          {
            offset: 150994944,
            bytes: 4194304,
            sha256: "65e125be9b19202c7a98970402d4eaa2ed964c0d22de8daf57e0cdd3fb9feda3"
          },
          {
            offset: 155189248,
            bytes: 4194304,
            sha256: "9d862916a65508d750c476e47c867c7ded1ee3ed2e413218285e8b75435ff6f4"
          },
          {
            offset: 159383552,
            bytes: 4194304,
            sha256: "da19351cde5e481a68d53ca981881b7ba88075201db13311f421107e49c2c471"
          },
          {
            offset: 163577856,
            bytes: 4194304,
            sha256: "f2037217fe89236fab4c8c57d72891cd2b2acdee4d641daf5d31cb041ddfaf3f"
          },
          {
            offset: 167772160,
            bytes: 4194304,
            sha256: "6f8766d2c3cb3dad66e901a744015f070e1e57a2250ab85202ea9a84cce3129f"
          },
          {
            offset: 171966464,
            bytes: 4194304,
            sha256: "80498c6b45cf0d1f84e105bc76509c777ac79dd9af247850d90387d2aa43c8ad"
          },
          {
            offset: 176160768,
            bytes: 4194304,
            sha256: "ecf851305fd66378023644b47a7c4b1b1cf006c052c5ebc94515956970af5bb3"
          },
          {
            offset: 180355072,
            bytes: 4194304,
            sha256: "18de31d8691d6027df376f5a608a2afda7d1e6f4fffa147dcfd7ffe948aafda8"
          },
          {
            offset: 184549376,
            bytes: 4194304,
            sha256: "aa30cde5920334c9fae59736fec879651ed5c755625eb9b189aa3825208c2610"
          },
          {
            offset: 188743680,
            bytes: 4194304,
            sha256: "85652a4236ea629e0397941bb7489af84261c19f57866900e59d2a05d7cadfe0"
          },
          {
            offset: 192937984,
            bytes: 4194304,
            sha256: "42b4fc81d3c5644999f94327db544351bc0fc8576389c4b7b48cb3688b93035b"
          },
          {
            offset: 197132288,
            bytes: 4194304,
            sha256: "91680fccc96fbdf6aa55c19e6d05e69d1e6266a9e52647096535568e7a799610"
          },
          {
            offset: 201326592,
            bytes: 4194304,
            sha256: "e65fa401aac5445935a9288c59e0a58840ff3cdeabef7ee2c25c8475ec07fb54"
          },
          {
            offset: 205520896,
            bytes: 4194304,
            sha256: "e6f8a9912ec8bd21f3111ca645885b4bfe06baaa48a49f4e40afd697c3adba90"
          },
          {
            offset: 209715200,
            bytes: 4194304,
            sha256: "d081a9ecf1ca087958352442be846131f661b2951d9b718d720c6677fc5ab2df"
          },
          {
            offset: 213909504,
            bytes: 4194304,
            sha256: "d4aaf58db6211596a7097deaa361149ed0dccbaddc4333f7c3326cbaee9447d4"
          },
          {
            offset: 218103808,
            bytes: 4194304,
            sha256: "9efdca0ab03c2cc417bb7bf0191e6d751966b5ad181ded88e8c20254c093f1a7"
          },
          {
            offset: 222298112,
            bytes: 4194304,
            sha256: "57f5598679c800d12f442a077cd445fa2b008911bcb84463b653af0bbd2650ca"
          },
          {
            offset: 226492416,
            bytes: 4194304,
            sha256: "166b4f1b16d5720c55f29c877f1be31c6f7fb5cb87211766389e836b918bd7d1"
          },
          {
            offset: 230686720,
            bytes: 4194304,
            sha256: "b31eb1de348a15284795dff306b79ce938f45c9e67853763003d4b3354bf74ab"
          },
          {
            offset: 234881024,
            bytes: 4194304,
            sha256: "4c226bbd4c5abc5167e9b47cfd08ef8cc3b038ee758633a359589cab5c1724cd"
          },
          {
            offset: 239075328,
            bytes: 4194304,
            sha256: "92e211769b630d4e4ee84dbaa896763e44ef894ef9da1aa0fe2a86b9c8ac24c5"
          },
          {
            offset: 243269632,
            bytes: 4194304,
            sha256: "464fcc8900e34aecdaa4768ed340576573835054324428dc921ccea6464aad16"
          },
          {
            offset: 247463936,
            bytes: 4194304,
            sha256: "025441ce5ebf37b9f62a1078db57b77c53ab949aff39a9fc8ccd44d94399ee91"
          },
          {
            offset: 251658240,
            bytes: 4194304,
            sha256: "b6d1ef8cabdba3d020b4790e69a1d9d0fc134c121b45aed2801677f1288a2096"
          },
          {
            offset: 255852544,
            bytes: 4194304,
            sha256: "61c293e0b3fb065dd49d6ef9cc1bd6b1b7d9be05146dd6359322e37e7047894b"
          },
          {
            offset: 260046848,
            bytes: 4194304,
            sha256: "6e854042f30d7ff8620ae6addcefd85a9b11458fdfc4faaea638faea067b1244"
          },
          {
            offset: 264241152,
            bytes: 4194304,
            sha256: "5a84720f145bae187c598fc53bad014db4a81d9dd85e1cbf2793d5267dade1d1"
          },
          {
            offset: 268435456,
            bytes: 4194304,
            sha256: "e8032b650d5514d8ef7049c5a4d1a2844946957ba0acee20f238268c9dc47eed"
          },
          {
            offset: 272629760,
            bytes: 4194304,
            sha256: "2bdb222da88054ae5f79bd816d26fb33868cb8755784b0be1fff7fce8a3f713d"
          },
          {
            offset: 276824064,
            bytes: 4194304,
            sha256: "9256b539d3872e6b4f87c1f5931516e1e98ac4f235d1c8be2682dc9ce06507ca"
          },
          {
            offset: 281018368,
            bytes: 4194304,
            sha256: "e4b8b6643c44ce88677e11101b12a13332a36504ab421450b723b7d34bd45deb"
          },
          {
            offset: 285212672,
            bytes: 4194304,
            sha256: "948d372f7d4e8cf54785ff90c601053a69b9e29030f4404df7c6cdf05712ea9b"
          },
          {
            offset: 289406976,
            bytes: 4194304,
            sha256: "b67c1e1bf99adae7f83be826039aaadead4db8be7eebef3c9e39b814a0ffbd00"
          },
          {
            offset: 293601280,
            bytes: 4194304,
            sha256: "38aeca1630f687255f114a233aff1f6c557ffb9324c58c4a17596eeeaa8460b5"
          },
          {
            offset: 297795584,
            bytes: 4194304,
            sha256: "d220d75af1f26bfe0d16b6bbd24e9b3089b64541071f7579e8d223cd9470f671"
          },
          {
            offset: 301989888,
            bytes: 4194304,
            sha256: "72152195bb984db3eda787b74d79e41b3860ee5211d1e0e264fc9c7662adaaf0"
          },
          {
            offset: 306184192,
            bytes: 4194304,
            sha256: "af27db6c5ce333e0f20515d0e5d600e610ddb045ca2ba2a832da78b635b883be"
          },
          {
            offset: 310378496,
            bytes: 4194304,
            sha256: "db072e2cc5fe8e55e2585ed442d1beac403be66033bb3ad1feb6151957fbe9a7"
          },
          {
            offset: 314572800,
            bytes: 4194304,
            sha256: "b54d3215cb7754d968279cd0799154890e060d6ad975490150e3b51338051569"
          },
          {
            offset: 318767104,
            bytes: 4194304,
            sha256: "d419496bbfb3fd1afb9ef7d266ec12a05ac76b0a23fa838bc12e234a9ec39cbf"
          },
          {
            offset: 322961408,
            bytes: 4194304,
            sha256: "513bc12d1b504c3376fc834d577cdbd5817a3321676c95fbea85f70b33111f90"
          },
          {
            offset: 327155712,
            bytes: 4194304,
            sha256: "edf5295a3d87cdc8b4537659bb56e2799c803624441b7bf5cbb5410d44d8fccb"
          },
          {
            offset: 331350016,
            bytes: 4194304,
            sha256: "9a0e32a7d814e241e2b8c67e06b5bcaed957209fe0b6d9db38fddd4cefa2b386"
          },
          {
            offset: 335544320,
            bytes: 4194304,
            sha256: "f432e2896aa9fc78452624c2e0ca0cdc0936ef93697d281549edaa7b7f82576d"
          },
          {
            offset: 339738624,
            bytes: 4194304,
            sha256: "27ed769355392d514fb34688ea94a19bb39c18c2aca030b243a2bf0cc8e92e1b"
          },
          {
            offset: 343932928,
            bytes: 4194304,
            sha256: "bb7dec67a7ced0f12b87c4a3901b06c62d0327886de00cc7196b67b56a3f74e6"
          },
          {
            offset: 348127232,
            bytes: 4194304,
            sha256: "9aeef8b3a5a3c26bd73981a456290855ba6304a08a6f009e230e9a53649fbf91"
          },
          {
            offset: 352321536,
            bytes: 4194304,
            sha256: "ec004a53a58ca5b10e8a74e5ec6b5044ca6d746e92a6c65855b1c75e4d551c08"
          },
          {
            offset: 356515840,
            bytes: 4194304,
            sha256: "8b32ce11413f86bfea71cfb6b9a7a17ffa8e248f0fb6ed6994e9893de15830d1"
          },
          {
            offset: 360710144,
            bytes: 4194304,
            sha256: "96e2eeec809c458cfa7c6dd9799efb56ac1b27556fcf585ade93e9d83ffee41f"
          },
          {
            offset: 364904448,
            bytes: 4194304,
            sha256: "7eb4c0b439a9e8865090ac5c668f3091e25e1847dedb18a482cb212489677c00"
          },
          {
            offset: 369098752,
            bytes: 4194304,
            sha256: "7bc959b384cca32c2bb1ebc2ffcc5dbb06b886eaa421f83c8752b22bb54d3a39"
          },
          {
            offset: 373293056,
            bytes: 4194304,
            sha256: "c05d8cffdb43c017fc8a3128b447752f37e68745825ab22218593e2c4b5370d7"
          },
          {
            offset: 377487360,
            bytes: 4194304,
            sha256: "f16d7f6ce2f19bcb064103c3f92bc5bfe1a15ab23ef0df2cfbaa71ca635cc58d"
          },
          {
            offset: 381681664,
            bytes: 4194304,
            sha256: "4f6a83693135411b50f3044990ebfbebd98050610e784c1bb59fde5611251a02"
          },
          {
            offset: 385875968,
            bytes: 4194304,
            sha256: "23a71b8f162d8a5c8403817838a23cd970c05623588ef5537f798754009056d9"
          },
          {
            offset: 390070272,
            bytes: 4194304,
            sha256: "788b22f0fcf810a304974f797e70862c8f577846922eb5450b003fa9311d1039"
          },
          {
            offset: 394264576,
            bytes: 4194304,
            sha256: "227ca4d5cdc4c52ee4ae3ef5bbdc6c0199e450242d2a0a54f593b6b250525cdc"
          },
          {
            offset: 398458880,
            bytes: 4194304,
            sha256: "db7abcae2dccf3b927b7d570744cadb455f8e43b5e7301b28f2bbeec784d21e1"
          },
          {
            offset: 402653184,
            bytes: 4194304,
            sha256: "4e463afc4ba873f6eea6cbb6c1c0e05811460f0eea3b28009e157bb50c75250b"
          },
          {
            offset: 406847488,
            bytes: 4194304,
            sha256: "8ef9366bb2abbec19c1fed0b206dce3b7b8c0a65f7008e42e908c06166ba402b"
          },
          {
            offset: 411041792,
            bytes: 4194304,
            sha256: "efd57bfb64ccd14b632c185e83917167b89177852d93f92dc9a89a2d5c4ddaa1"
          },
          {
            offset: 415236096,
            bytes: 4194304,
            sha256: "2ea89200f5996208e9618ac3b3612f223d0b8fc4fe0bfc7f8fd5201e2678f679"
          },
          {
            offset: 419430400,
            bytes: 4194304,
            sha256: "cd1ef3672dcfb0fa3a4456e765c8a8e3c2970bc79de3dd773fec62b4b4e8b6cf"
          },
          {
            offset: 423624704,
            bytes: 4194304,
            sha256: "1a5e4c2e2b392e7a6ddbf427ca2f9c38e45c1af25a40029a7351dec1feca2d32"
          },
          {
            offset: 427819008,
            bytes: 4194304,
            sha256: "77510e0cf3e4c3ebfc700f321dcb9f9e312fbc35cc33c2f7d280465ae4f71ea9"
          },
          {
            offset: 432013312,
            bytes: 4194304,
            sha256: "37d3628af7118770be1f64f9e3c5000ee94b04e296dc28e20c24a2c476dd95e7"
          },
          {
            offset: 436207616,
            bytes: 4194304,
            sha256: "78ac50a8c3b3d280a8ac95c77fd68502c209587ab4de671240543af678748497"
          },
          {
            offset: 440401920,
            bytes: 411648,
            sha256: "e385bfa69ab9f228f2e7f8b302a636a5c09d6f8a0440e57c593237a4423535d6"
          }
        ]
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_local_cached_step.onnx",
        bytes: 53685,
        sha256: "aa9035fefc1c138a951a8bcfc0374fb03a25f1ece67f7f7f53bce349b84a1dd5"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_local_decoder.onnx",
        bytes: 49231,
        sha256: "51aa754301b38550a5f9adda0ad93bd3dc95819afb511e6dcabf4a90b345a454"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_local_fixed_sampled_frame.onnx",
        bytes: 471262,
        sha256: "40cdb00efc171c450cf91468e01429caa41b0252222cd308e978f58fe354afa8"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_local_shared.data",
        bytes: 229678080,
        sha256: "bae7782032c0fb12490ab42afe009f87ae6c75a0f0596fc7b5c08e4d5ee93916",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "52b04456dac4371ddc6e2028b5b678c8d0d956b62bbedf36e33e18340b18e427"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "405cf8ea3fffb1ad698f626dece3e8d0d0d6f7c311c0ed221ec4ef6de35c62ed"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "356334c1fa1d3f40b858d87c54386899dbce4192189e8218000076e0d019ee72"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "b33b1564b0521a2a4f2d714b5824d0932d4142b34a2e65768e150d8c5143248a"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "448edc0a7aefbe947fe58af869e7b9b715dee82e16dee80b24363b61839b41fa"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "26c1a12566337a127a923f1d1cdc1c790fd2732894384ed6289c98c741fe92a5"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "44ee5330d4e3e6a8b6f8a0e05d080e3c009c3bd9d7c74f524c474a624d2b4924"
          },
          {
            offset: 29360128,
            bytes: 4194304,
            sha256: "c99f395f276f44bf8dfa8d3907f05b03d8dc7d966ab3407df868361cdb2c8b98"
          },
          {
            offset: 33554432,
            bytes: 4194304,
            sha256: "f3ee00b7d450ebcae3eda2e90b577890ace247d791eb69f6582b340b00a0229e"
          },
          {
            offset: 37748736,
            bytes: 4194304,
            sha256: "812238dd3da16c5db8b9570196d57713e20e01c414b83da42d943d3f4708d2e7"
          },
          {
            offset: 41943040,
            bytes: 4194304,
            sha256: "40e58b70e8e54d072d920c6a909496cfa3e28c667a29eb43a69d05a354c54c81"
          },
          {
            offset: 46137344,
            bytes: 4194304,
            sha256: "ec062543beba519fd58d95c094156ec8fbcf3c85d18749c061e1ab406eb0e177"
          },
          {
            offset: 50331648,
            bytes: 4194304,
            sha256: "51b1c693f620d44cd26d35a691e3143080444cf4ff1b81fe7c08dcf7c32a97ce"
          },
          {
            offset: 54525952,
            bytes: 4194304,
            sha256: "d5797d9f9ea392b8ca985a5541339471aa18030686e76428bdcded32e829d2f3"
          },
          {
            offset: 58720256,
            bytes: 4194304,
            sha256: "f8a3ae9e03ee7770e7d3283038f6ef5f3030d90727271bee9bb8214e3219600e"
          },
          {
            offset: 62914560,
            bytes: 4194304,
            sha256: "cf09c8f356abb7878e23b91410af424591d5d3c1ebe52c8b01bc3ea9e611c689"
          },
          {
            offset: 67108864,
            bytes: 4194304,
            sha256: "af67e4c5dbb913237c5d22b5e5614e87cbbb2a064b7a12fcf1d2d19e1c5b8872"
          },
          {
            offset: 71303168,
            bytes: 4194304,
            sha256: "adda596cd15058704e9410f615b7b3ed837b1d28cab04384b89261a40aa2908d"
          },
          {
            offset: 75497472,
            bytes: 4194304,
            sha256: "d35b9a5a451ff0004d074c3f8605f65b154ba66824ef8348c7ed30666292fbfd"
          },
          {
            offset: 79691776,
            bytes: 4194304,
            sha256: "916dd5d1bbc9496b3638601f75de02e4148835388895e8de4f26168ad9a7b37d"
          },
          {
            offset: 83886080,
            bytes: 4194304,
            sha256: "42b5db341f32eb4359041b932cdb8de3241df76b14f1d09d0f33234242532bff"
          },
          {
            offset: 88080384,
            bytes: 4194304,
            sha256: "584d14d76e1ab5c97214fefb4489d9e66bca0184c922fbae8b377541d86c2a3d"
          },
          {
            offset: 92274688,
            bytes: 4194304,
            sha256: "87bbda06dfadd2c89200ad15b2aeb0b7cc22596451f8f851a826b3678be22d09"
          },
          {
            offset: 96468992,
            bytes: 4194304,
            sha256: "5a9b0d0444da7b32708de14e9ded468ac91b0d39982c679f6193c3bf68a0868b"
          },
          {
            offset: 100663296,
            bytes: 4194304,
            sha256: "e65772a983d81e4e3a1e5dad626a4d2c2d6b114b484703f8b4fdf9bbfb3a99a1"
          },
          {
            offset: 104857600,
            bytes: 4194304,
            sha256: "bf44025f492e31861ea5373fdad2c1b9640cef98c3038c23de880f520aac36f0"
          },
          {
            offset: 109051904,
            bytes: 4194304,
            sha256: "182f3111c479a5aa9212a7640a959cb60e90919506272295c611ed89e29959dc"
          },
          {
            offset: 113246208,
            bytes: 4194304,
            sha256: "6e5ece215a6cdbcf99445edd4f64c8e95f9ebc8170cc89c6cf7b53df7e1dff97"
          },
          {
            offset: 117440512,
            bytes: 4194304,
            sha256: "a7da55462cccb44ab942392bc24d4f116b90f58e348fe56adeb39cec81906c7b"
          },
          {
            offset: 121634816,
            bytes: 4194304,
            sha256: "ee2830076a9eb8a0bc135009e6af55eaaf70c9a53bcdd90234927570464763e4"
          },
          {
            offset: 125829120,
            bytes: 4194304,
            sha256: "71d776a1acffeef819b49067a7f029315bafd8fe2913c7d17ad4a27d0277fc6d"
          },
          {
            offset: 130023424,
            bytes: 4194304,
            sha256: "f218b7fc3112de2a5eb16f03915c039b274d1180d600bf57094cd78627d6d975"
          },
          {
            offset: 134217728,
            bytes: 4194304,
            sha256: "faa65a8e921c67e5aa9a18c713cb1a1105059a0f8f9ced3dd816e393986b5bcf"
          },
          {
            offset: 138412032,
            bytes: 4194304,
            sha256: "26fbecf0accd98e76bcfdde9b9ea8f2318d416f31ab0a93b29084aa6b204f270"
          },
          {
            offset: 142606336,
            bytes: 4194304,
            sha256: "02ddea027e12c48a38b261e817f2d4177612eaa151c1ebdaee79d675b74ccda4"
          },
          {
            offset: 146800640,
            bytes: 4194304,
            sha256: "5506a0ada0e167a0ab58561229389661501e059ce4727cfe2be7fbc44fde742b"
          },
          {
            offset: 150994944,
            bytes: 4194304,
            sha256: "0c434e4ae2d03c5bebf78df88433ff8eb65e6ac72e5051139df143789aa84dc5"
          },
          {
            offset: 155189248,
            bytes: 4194304,
            sha256: "6ff727a0ad04f257b43ec30a3e2e0b31db65dc05764fdea8a240c1aa277827bf"
          },
          {
            offset: 159383552,
            bytes: 4194304,
            sha256: "0bd9216525d95d24e649f2d56631c2fcb18d79ba41e417d11eff8797755ff6d9"
          },
          {
            offset: 163577856,
            bytes: 4194304,
            sha256: "b43c45a9e44c3f06d774a38063a46346e0e54bac4716f84c9b253a0e3402b737"
          },
          {
            offset: 167772160,
            bytes: 4194304,
            sha256: "17c2ca9a4c41fe7a25e3a1139d31fda27062c02a9ec63d8a06f38eda8b35fbfc"
          },
          {
            offset: 171966464,
            bytes: 4194304,
            sha256: "99c33b3795a40be18eeebf4666859f507bc95104768601158ccfcfb78d5c12e3"
          },
          {
            offset: 176160768,
            bytes: 4194304,
            sha256: "bb36e13e8de633bc844c83191101a5ba6d30812cf9379636c1a2f32224898166"
          },
          {
            offset: 180355072,
            bytes: 4194304,
            sha256: "7e31a9b408467359ef3ab1338cc9527606377028fee2680738ea64176a37d200"
          },
          {
            offset: 184549376,
            bytes: 4194304,
            sha256: "b0d009b4816e93b82fa80ed315014c954c263701de6dd49750806b1a9acc93c1"
          },
          {
            offset: 188743680,
            bytes: 4194304,
            sha256: "5cbd0427e078fb08d56dc1ef7d400797d5a8d1aba59a9c1f9f40612d9d5f261f"
          },
          {
            offset: 192937984,
            bytes: 4194304,
            sha256: "bf81c2a7bcb76b9752903120eed3de0944c54f2cf1c0404b75a9114cb89421c4"
          },
          {
            offset: 197132288,
            bytes: 4194304,
            sha256: "ef0006c2759731cd825ed772fa5be53ef3f41165b8f67e55e8bafd367068f85f"
          },
          {
            offset: 201326592,
            bytes: 4194304,
            sha256: "dedd303529c73dd563cf16bc59ae960ff91aeba935e033e2ab6e5f523c389fdf"
          },
          {
            offset: 205520896,
            bytes: 4194304,
            sha256: "56ba3d23e8a4104a47ceba448770f29135da6b9732fe8c3a49814aa64b0ce832"
          },
          {
            offset: 209715200,
            bytes: 4194304,
            sha256: "939bcf833b6348ba139d62da17f7764eaff8c1617261b4acc9d1cb43454dbc9c"
          },
          {
            offset: 213909504,
            bytes: 4194304,
            sha256: "c77b8b15f31788e5b3cf2547b61fc3e790284f8d68a26068e0d66d2dd8e70551"
          },
          {
            offset: 218103808,
            bytes: 4194304,
            sha256: "0ad59138984154180cf5b4132b9a12a16b6f55c0590ae33cb1fda3a4c8b9ad9a"
          },
          {
            offset: 222298112,
            bytes: 4194304,
            sha256: "fd8f1b6ec1d534cb84b1142ddc5c8468eb67a11d5a4b9a0c567d3a6f81aa2feb"
          },
          {
            offset: 226492416,
            bytes: 3185664,
            sha256: "a50b4b88ed3caf00cab9c11176b4276e2dbbe4016bd22d6c108fb1ff41bf0f4d"
          }
        ]
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/moss_tts_prefill.onnx",
        bytes: 283305,
        sha256: "d56126dcd0574c2f15d98fc6b35eda68d0386b5bd9c5e38e28548d6f2ea8f3db"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/tokenizer.model",
        bytes: 470897,
        sha256: "c353ee1479b536bf414c1b247f5542b6607fb8ae91320e5af1781fee200fddff"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-TTS-Nano-100M-ONNX/tts_browser_onnx_meta.json",
        bytes: 4487,
        sha256: "3edf25232dcd0af3d061c837e9a968a39e2f8592e06777d740503c4f2244f95c"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/codec_browser_onnx_meta.json",
        bytes: 17036,
        sha256: "3e291c883bb7d11ff2fe8e964e3e495519760358859f35c951254c7741592731"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/moss_audio_tokenizer_decode_full.onnx",
        bytes: 681902,
        sha256: "0fbbafe3fd4afa2a019af5c5ced204af6e2d1db044fa40f021525d2aee95b4ac"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/moss_audio_tokenizer_decode_shared.data",
        bytes: 44198912,
        sha256: "e69d52e0f4e84ca27850557ee54face46632d3a5a16c89bd246c7c408466dcad",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "69d67e96943402d428d42ecd0bb8fea7e494913887e91f90795e353ce1b447b6"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "14f4ced2234daa2d84ac34efab1cfffdb3392ee15006c3e51da52eda388a234a"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "658ae033cb5e43b95ddc69fc03ba4c595fd6d3aa8b9651f65797894bf8cfbee3"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "0c11fcc6e06f5a85156fd3de3b03d61145b37ba71c7af3290e9882722e59fcc6"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "eead6306018100d8b48481e7865411cc790bcd15671414c31946c5c28102769b"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "babe3368ed2d5c7fb4c1f8c20338e72ba845c8eb8aefc21e2f9fda8c8014df20"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "2c77ac4712f1bb8ae9209e4920df130ed86919cb06f80859b808c6319fcb716d"
          },
          {
            offset: 29360128,
            bytes: 4194304,
            sha256: "cea6d9c08fc1f5fdf8cd0538bc1494438bbaa02471f6e8f36e05274a974f2c41"
          },
          {
            offset: 33554432,
            bytes: 4194304,
            sha256: "f8d18aa00582d4ec3c6c85c6f93745eca6b304da499937b0ab2e57e2a742a5a4"
          },
          {
            offset: 37748736,
            bytes: 4194304,
            sha256: "0fbcc1a18aacbaa780cae78fb213b8bc4768fa4f7da5c3cf7530ffec5c1eb136"
          },
          {
            offset: 41943040,
            bytes: 2255872,
            sha256: "4b20ea1ed4ed7c62b020951446273458f697db289429c2efded1b2dc601b45a2"
          }
        ]
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/moss_audio_tokenizer_decode_step.onnx",
        bytes: 351400,
        sha256: "9527c86a29e1837edec1f74db57d5eeaadb3a715af3382703566460afed25855"
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/moss_audio_tokenizer_encode.data",
        bytes: 44507136,
        sha256: "aa751265b2bab2887eac224484546b194875aa7494b607115439b3dc6b228a2c",
        segments: [
          {
            offset: 0,
            bytes: 4194304,
            sha256: "34a550d1c650219a66ccbb2589b0e6a9a3409893824fcacf09aa7278bac41970"
          },
          {
            offset: 4194304,
            bytes: 4194304,
            sha256: "a8c0fa9f6c7493edf27e739f2e03adee174080296c1a0fd19ff9c6269049f034"
          },
          {
            offset: 8388608,
            bytes: 4194304,
            sha256: "3002bb9da89db09ba48438b169d4c9bffb8141dbb7751181d93f1834248bbfbd"
          },
          {
            offset: 12582912,
            bytes: 4194304,
            sha256: "8f30e1a33c5814be9c956c5829d74655f82abe233b606d53de66da75a5ce3d70"
          },
          {
            offset: 16777216,
            bytes: 4194304,
            sha256: "54499be0248c636350893dcf4e2118a896574b3accedcddf1e453561d55b3d43"
          },
          {
            offset: 20971520,
            bytes: 4194304,
            sha256: "cb50778dad2dd836abde432042479ec093e2efa1940746a79c4db70c5e48acdc"
          },
          {
            offset: 25165824,
            bytes: 4194304,
            sha256: "af2b38d95ed6c6885294e74322f87a29d5cd82e31b3a97fbe712c2308869ceed"
          },
          {
            offset: 29360128,
            bytes: 4194304,
            sha256: "ed3c34e3c2cd4570494bc3be24445af2bac47f71f127246a366785e2638143c4"
          },
          {
            offset: 33554432,
            bytes: 4194304,
            sha256: "06e44878511211ec600679e22b1d6a46a51cf86e5cd4b92f517aa7b72da82306"
          },
          {
            offset: 37748736,
            bytes: 4194304,
            sha256: "21525c06f159947eb2528219eb9f0a9427befa7987e87d9de4af1dd79f582e79"
          },
          {
            offset: 41943040,
            bytes: 2564096,
            sha256: "a5eb4df116017e2ea9f3e0a1f116ccaa82bba2b37c2549c116f49deb6986f80a"
          }
        ]
      },
      {
        path: "/models/tts/local-moss-tts-nano-100m-onnx-v1/MOSS-Audio-Tokenizer-Nano-ONNX/moss_audio_tokenizer_encode.onnx",
        bytes: 815775,
        sha256: "eadea4a645abdcf98714c7aead122ee2ce7da6e080f9f80b977cd1ca8e19473a"
      }
    ]
  }
};
